import React from "react";
import { education } from "../libs/education";

export default function EducationCard() {
  return (
    <div className="w-full font-sans text-gray-300 h-full flex flex-col">
      <div className="font-semibold text-2xl text-gray-300 px-5 pt-4 pb-2">Education</div>
      <div className="flex flex-col divide-y divide-white/5 flex-1">
        {education.map((item, i) => (
          <div key={i} className="px-5 py-4">
            <div className="flex items-baseline justify-between gap-2">
              <p className="text-sm font-semibold text-white">{item.institution}</p>
              <span className="text-xs text-gray-500 shrink-0">{item.dates}</span>
            </div>
            <p className="text-xs text-gray-400 mt-1">
              {item.degree} · {item.field}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
